import { Address } from './address';

export type AuxiliaryContactRelationship = 'resident' | 'renter' | 'family' | 'other';

export const AUXILIARY_CONTACT_RELATIONSHIPS: { value: AuxiliaryContactRelationship; label: string }[] = [
    { value: 'resident', label: 'Resident' },
    { value: 'renter', label: 'Renter' },
    { value: 'family', label: 'Family member' },
    { value: 'other', label: 'Other' },
];

export function auxiliaryContactRelationshipLabel(relationship: string | null | undefined): string {
    return AUXILIARY_CONTACT_RELATIONSHIPS.find((r) => r.value === relationship)?.label ?? '';
}

export class AuxiliaryContact
{
    id: number;
    type: string;
    unitId: number|null;
    name: string;
    email: string;
    phone: string;
    relationship: AuxiliaryContactRelationship | null = null;
    ownersCanView: boolean = false;
    ownersCanEdit: boolean = false;
    address: Address;

    constructor(contact: any) {
        if (contact.id) {
            this.id = contact.id;
        }

        if(contact.contactableType === 'App\\Models\\Entities\\Unit') {
            this.unitId = contact.contactableId;
        }

        this.type = (contact.contactableType ?? '') === '' ? 'unit' : contact.contactableType;

        if (contact.name) {
            this.name = contact.name;
        }

        this.email = contact.email;

        this.phone = contact.phone;

        if (contact.relationship) {
            this.relationship = contact.relationship;
        }

        if(contact.ownersCanView) {
            this.ownersCanView = contact.ownersCanView;
        }

        if(contact.ownersCanEdit) {
            this.ownersCanEdit = contact.ownersCanEdit;
        }

        if (contact.address) {
            this.address = new Address(contact.address);
        }
    }
}
